module.exports = __webpack_public_path__ + "static/img/img-box.e36e9613.png";